import styled from 'styled-components'

export const Icon = styled.svg.attrs<SvgProps>(
  ({ theme, color, strokeWidth }) => ({
    version: '1.1',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink',
    //strokeWidth: strokeWidth ? strokeWidth : 2,
    fill: 'none',
    stroke: color ? color : theme.text,
  })
)``

interface SvgProps {
  color?: string
  strokeWidth?: number
}

export const Svg = styled(Icon)<SvgProps>`
  width: 24px;
  height: 24px;
`
